export const transformOneApiResponse = (apiResponse) => {
  if (!apiResponse || !apiResponse.scheduleLines) return [];

  return apiResponse.scheduleLines.map((line) => {
    const journey = line.journeys && line.journeys[0];
    const sailInfo = line.sailInfo && line.sailInfo[0];

    return {
      departure: {
        date: journey?.departureDate ? journey.departureDate.split(" ")[0] : "",
        location: journey?.polLocationName || line.porName || "",
        code: journey?.polCode || line.porCode || "",
      },
      arrival: {
        date: journey?.berthingDate || journey?.podArrivalDate || "",
        location: journey?.podLocationName || line.delName || "",
        code: journey?.podCode || line.delCode || "",
      },
      vessel: {
        name: journey?.vesselName || sailInfo?.vsslName || "",
        voyage: sailInfo?.vvd?.slice(-3) || "",
        imoNumber: "N.A.",
        flag: "-",
        built: "-",
        service: journey?.serviceLaneCode || "",
        callSign: "N.A.",
      },
      travelTime: journey?.transitTime || "",
      deadlines: {
        cct: line?.cct || "N.A.",
        dct: line?.dct || "N.A.",
        vgmCct: line?.vgmCct || "N.A.",
      },
    };
  });
};



// Função para transformar a resposta da API MSC na estrutura desejada
export const transformMscApiResponse = (apiResponse) => {
  if (!apiResponse || !apiResponse.value) return [];

  const { value } = apiResponse;

  // Função auxiliar para encontrar o cut-off time por código
  const getCutOffTime = (cutOffs, code) => {
    const cutOff = cutOffs.find((c) => c.cutOffDateTimeCode === code);
    return cutOff ? cutOff.cutOffDateTime.split("T")[0] : "N.A.";
  };

  // Encontrar a perna principal (VESSEL) para informações do navio
  const vesselLeg = value.legs.find((leg) => leg.transport.modeOfTransport === "VESSEL");
  const vessel = vesselLeg?.transport.vessel || {};

  return [
    {
      departure: {
        date: value.placeOfReceipt.dateTime ? value.placeOfReceipt.dateTime.split("T")[0] : "",
        location: value.placeOfReceipt.location?.unLocationCode || "",
        code: value.placeOfReceipt.location?.unLocationCode || "",
      },
      arrival: {
        date: value.placeOfDelivery.dateTime ? value.placeOfDelivery.dateTime.split("T")[0] : "",
        location: value.placeOfDelivery.location?.unLocationCode || "",
        code: value.placeOfDelivery.location?.unLocationCode || "",
      },
      vessel: {
        name: vessel.name || "N.A.",
        voyage: "", // Não há um campo direto para voyage no exemplo, pode ser ajustado conforme necessário
        imoNumber: vessel.vesselImoNumber || "N.A.",
        flag: vessel.flag || "-",
        built: "-", // Não disponível no exemplo
        service: "", // Não disponível no exemplo, pode ser ajustado
        callSign: vessel.callSign || "N.A.",
      },
      travelTime: value.transitTime || "",
      deadlines: {
        cct: getCutOffTime(value.cutOffTimes, "DCO"), // Document Cut-off
        dct: getCutOffTime(value.cutOffTimes, "RCO"), // Regular Cut-off
        vgmCct: getCutOffTime(value.cutOffTimes, "VCO"), // VGM Cut-off
      },
    },
  ];
};


export const transformCmaApiResponse = (apiResponse) => {
  if (!apiResponse || !Array.isArray(apiResponse)) return [];

  return apiResponse.map((item) => ({
    departure: {
      date: item['departure-date'] || '',
      location: item.origin || '',
      code: item['origin-type'] === 'POL' ? item.origin.split(', ')[1] : '',
    },
    arrival: {
      date: item['arrival-date'] || '',
      location: item.destination || '',
      code: item['destination-type'] === 'POD' ? item.destination.split(', ')[1] : '',
    },
    vessel: {
      name: item['vessel-name'] || 'N.A.',
      voyage: item['voyage-ref'] || '',
      imoNumber: 'N.A.',
      flag: '-',
      built: '-',
      service: item['service-name'] || '',
      callSign: 'N.A.',
    },
    travelTime: item['transit-time'] || '',
    deadlines: {
      cct: item['standard-booking-cut-off'] ? item['standard-booking-cut-off'].split(', ')[0] : 'N.A.',
      dct: item['port-cut-off'] ? item['port-cut-off'].split(', ')[0] : 'N.A.',
      vgmCct: item['vgm-cut-off'] ? item['vgm-cut-off'].split(', ')[0] : 'N.A.',
    },
  }));
};


export const transformNewMscApiResponse = (apiResponse) => {
  if (!apiResponse || !apiResponse.IsSuccess || !apiResponse.Data || !apiResponse.Data[0]?.Routes) {
    return [];
  }

  const routes = apiResponse.Data[0].Routes;

  return routes.map((route) => ({
    departure: {
      date: route.EstimatedDepartureDate ? route.EstimatedDepartureDate.split('T')[0] : '',
      location: route.RouteScheduleLegDetails[0]?.DeparturePortName || '',
      code: route.RouteScheduleLegDetails[0]?.DeparturePortUNCode || '',
    },
    arrival: {
      date: route.EstimatedArrivalDate ? route.EstimatedArrivalDate.split('T')[0] : '',
      location: route.RouteScheduleLegDetails[0]?.ArrivalPortName || '',
      code: route.RouteScheduleLegDetails[0]?.ArrivalPortUNCode || '',
    },
    vessel: {
      name: route.VesselName || 'N.A.',
      voyage: route.DepartureVoyageNo || '',
      imoNumber: route.RouteScheduleLegDetails[0]?.Vessel?.VesselImoCode || 'N.A.',
      flag: route.RouteScheduleLegDetails[0]?.Vessel?.VesselFlag || '-',
      built: route.RouteScheduleLegDetails[0]?.Vessel?.VesselBuiltYear || '-',
      service: route.RouteScheduleLegDetails[0]?.MaritimeServiceName || '',
      callSign: 'N.A.',
    },
    travelTime: route.TotalTransitTime || '',
    deadlines: {
      cct: route.CutOffs?.ShippingInstructionsCutOffDate || 'N.A.',
      dct: route.CutOffs?.ContainerYardCutOffDate || 'N.A.',
      vgmCct: route.CutOffs?.VerifiedGrossMassCutOffDate || 'N.A.',
    },
  }));
};


